import { Skeleton } from "@/components/ui/skeleton";

/**
 * Placeholder while the auth screens resolve their initial query.
 *
 * Deliberately not wrapped in <AuthLayout />: that needs the configuration
 * context and would render the logo and language switcher, which is more than a
 * skeleton should commit to. It only borrows the backdrop and card geometry so
 * the real card does not jump into place afterwards.
 */
export const LoginSkeleton = () => {
  return (
    <div
      className="min-h-screen flex items-start justify-center p-6 pt-12"
      style={{
        backgroundColor: "#0f172a",
        backgroundImage: "url(/ai-brain-bg.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="w-full max-w-md">
        <div className="rounded-xl border border-white/20 bg-white/10 p-6 shadow-2xl backdrop-blur-md">
          <div className="flex flex-col items-center gap-4">
            <Skeleton className="size-20 rounded-lg bg-white/20" />
            <Skeleton className="h-7 w-1/2 bg-white/20" />
            <Skeleton className="h-4 w-2/3 bg-white/20" />
          </div>
          <div className="mt-8 flex flex-col gap-4">
            <Skeleton className="h-9 w-full bg-white/20" />
            <Skeleton className="h-9 w-full bg-white/20" />
            <Skeleton className="h-9 w-full bg-white/20" />
          </div>
        </div>
      </div>
    </div>
  );
};
